"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingView = function LoadingView(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "loading-container flex justify-content-center flex1"
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: size
  }));
};

LoadingView.defaultProps = {
  size: 45
};
var _default = LoadingView;
exports.default = _default;